import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../../shared/context/auth-context'; 
import CourseItem from '../course-comp/courseItem';
import { Link } from 'react-router-dom/cjs/react-router-dom';
// import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';


import './course.css';


const Course = () => {
  const auth = useContext(AuthContext);

  const [currentSlide, setCurrentSlide] = useState(0)
  

  const [courseData, setCourseData] = useState([]);

  const courseLength = courseData.length;

  // courseLength = 1 2 3 
  // currentSlide = 0 1 2 

  const autoScroll = true;
  let slideInterval;
  let intervalTime = 5000;
 
  const nextSlide = () => {
    setCurrentSlide(currentSlide === courseLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? courseData.length - 1 : currentSlide - 1)
  }

  function auto() {
    slideInterval = setInterval(nextSlide, intervalTime)
  }
  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/course');
        const responseData = await response.json();
        setCourseData(responseData.course)
      } catch (err) {
        console.log(err.message)
      }
    }
    fetchCourse();
    setCurrentSlide(0);
    
  }, []);
    
  useEffect(() => {
    if ( autoScroll ) {
      auto()
    };
    return () => clearInterval(slideInterval)
  },[currentSlide])
 

  return (     
    <main className='course-container'>
      {auth.isLoggedIn && auth.user && auth.user.role === 'admin' && ( 
        <Link to='/add-course'>
          <div className='add-course-link'> + Add Course</div>
        </Link>
      )}
  
      {courseData && courseData.map((course, index) => (                  
        <div key={index} className='course-controller' >    
    
          <CourseItem  
            id={course.id}               
            title={course.title}
            intro={course.intro}
            who={course.who}
            image={course.image}
            day={course.day}
            time={course.time}
            date={course.date}
            location={course.location}
            createdAt={course.createdAt}
          />  
        </div>              
      ))}
     
{/* 
 <AiOutlineArrowLeft className="arrow prev" onClick={prevSlide}/>
        
       {courseData && courseData.map((course, index) => (                  
        <div key={index} className='course-controller' >    
       
        {index === currentSlide && (       
          <CourseItem 
            id={course.id}               
            title={course.title}
            intro={course.intro}
            who={course.who}
            image={course.image}
            day={course.day}
            time={course.time}
            date={course.date}
            location={course.location}
            createdAt={course.createdAt}
          />                      
          
        )}
         
        </div>              
      ))}<AiOutlineArrowRight className='arrow next' onClick={nextSlide}/>
       */}
    </main>
  )
}
export default Course;